module.exports = __webpack_public_path__ + "static/media/Creation-2023.0a414a70.jpg";